// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:ds:IFGQ4z */\n.B2yt_{grid-gap:var(--audio-spacing-8);display:grid;gap:var(--audio-spacing-8);grid-template-columns:minmax(0,1fr)}@media (min-width:768px){.B2yt_{gap:var(--audio-spacing-16);grid-template-columns:repeat(auto-fill,10.625rem)}}@media (min-width:1280px){.B2yt_{grid-template-columns:repeat(auto-fill,11.25rem)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "B2yt_"
};
export default ___CSS_LOADER_EXPORT___;
